const ACTION_PATH = 'app/pressaoBiodiversidade'

export const CALL_LISTAR_DADOS_PRESSAO_BIODIVERSIDADE = `${ACTION_PATH}/CALL_LISTAR_DADOS_PRESSAO_BIODIVERSIDADE`

export const callListarDadospressaoBiodiversidade = (payload) => ({
  type: CALL_LISTAR_DADOS_PRESSAO_BIODIVERSIDADE,
  payload,
})
